import { navLinks, siteInfo } from '@/mocks/buzz';

export default function Footer() {
  return (
    <footer className="border-t border-paper bg-leaf-900 text-leaf-50">
      <div className="mx-auto grid w-full max-w-7xl gap-8 px-4 py-12 md:grid-cols-[1.4fr_1fr_1fr] md:px-6">
        <div>
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-coral-500 text-white">
              <i className="ri-news-fill text-lg" />
            </span>
            <span className="font-display text-xl">{siteInfo.brand}速览</span>
          </a>
          <p className="mt-4 max-w-sm text-sm leading-6 text-leaf-200">
            {siteInfo.desc}高效汇总当日要闻，通勤路上轻松补完全部课代表内容。
          </p>
        </div>

        <nav aria-label="页脚导航">
          <h4 className="text-sm font-black text-white">快速导航</h4>
          <ul className="mt-4 grid grid-cols-2 gap-2.5">
            {navLinks.map((l) => (
              <li key={l.id}>
                <a
                  href={`#${l.id}`}
                  className="whitespace-nowrap text-sm text-leaf-200 transition-colors hover:text-white"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h4 className="text-sm font-black text-white">联系与合作</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-leaf-200">
            <li className="inline-flex items-center gap-2 whitespace-nowrap">
              <i className="ri-mail-line" /> {siteInfo.email}
            </li>
            <li className="inline-flex items-center gap-2 whitespace-nowrap">
              <i className="ri-time-line" /> 每日三档更新 · 9:00-22:00
            </li>
            <li className="inline-flex items-center gap-2 whitespace-nowrap">
              <i className="ri-leaf-line" /> 坚持先看全、再精简的内容原则
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-leaf-800">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-leaf-300 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} {siteInfo.brand}速览 · 保留所有权利</p>
          <p className="inline-flex items-center gap-1 whitespace-nowrap">
            本站内容仅供娱乐速览演示使用
            <i className="ri-heart-3-fill text-coral-400" />
          </p>
        </div>
      </div>
    </footer>
  );
}